module.exports = __webpack_public_path__ + "img/cloud.719ceb71.png";